import { render } from "./index.vue?vue&type=template&id=6cef10f5"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "C:\\essoduke\\Web\\health-click.dev\\app\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/js/hcv2/vue/views/campaign/luckybox/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cef10f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cef10f5', __exports__)) {
    console.log('reload')
    api.reload('6cef10f5', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6cef10f5", () => {
    console.log('re-render')
    api.rerender('6cef10f5', render)
  })

}


export default __exports__